import { queryOptions } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import { showEInvoicePreview } from "~/modules/billing/api/eInvoice/eInvoiceApiDispatchers.ts";

export const eInvoiceQueries = {
	baseKey: ["e-invoice"],
	preview: (invoiceId: string, enabled: boolean) =>
		queryOptions({
			queryKey: [...eInvoiceQueries.baseKey, invoiceId],
			queryFn: () => showEInvoicePreview(invoiceId).then(getDataFromResponse),
			enabled,
		}),
};